import { TeamPanel } from '../panels/TeamPanel';

/**
 * Component that renders the team panel
 */
export const TeamSection = () => {
  return <TeamPanel />;
};